import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { LogIn, ShieldCheck, ArrowLeft } from "lucide-react";
import { fetchMe } from "@/lib/api";

export default function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    // If already authenticated, jump to portal
    fetchMe()
      .then(() => navigate("/portal", { replace: true }))
      .catch(() => {});
  }, [navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/portal";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="login-page" className="min-h-[70vh] container-pad py-20 flex items-center">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 w-full">
        <div className="md:col-span-6 flex flex-col justify-center">
          <Link to="/" className="inline-flex items-center gap-2 text-muted2 hover:text-navy text-sm mb-8">
            <ArrowLeft size={16} /> Back to site
          </Link>
          <div className="overline">Secure client portal</div>
          <h1 className="font-display text-5xl text-navy mt-4 tracking-tight leading-[1.05]">
            Sign in to your Elevate workspace.
          </h1>
          <p className="text-muted2 mt-6 max-w-md leading-relaxed">
            Track your registration progress, access your documents, and stay across compliance actions all in one place.
          </p>
          <ul className="mt-8 space-y-3 text-sm text-ink">
            <li className="flex items-center gap-3"><ShieldCheck size={16} className="text-teal" /> One click Google sign in via Emergent Auth</li>
            <li className="flex items-center gap-3"><ShieldCheck size={16} className="text-teal" /> 7-day secure session, HTTP only cookie</li>
            <li className="flex items-center gap-3"><ShieldCheck size={16} className="text-teal" /> Your case file, documents and next actions</li>
          </ul>
        </div>
        <div className="md:col-span-6">
          <div className="bg-brand-gradient text-canvas rounded-3xl p-10 md:p-14 grain relative overflow-hidden">
            <div className="overline relative" style={{ color: '#A7E0E6' }}>Login</div>
            <h2 className="font-display text-3xl mt-3 relative">Continue with Google</h2>
            <p className="text-canvas/80 mt-4 text-sm leading-relaxed relative">
              We use Emergent's hosted Google sign in. Your Google account is the only thing you need.
            </p>
            <button
              data-testid="google-login-btn"
              onClick={handleLogin}
              className="btn-light-on-navy w-full justify-center mt-8 relative"
            >
              <LogIn size={16} /> Sign in with Google
            </button>
            <p className="text-xs text-canvas/60 mt-6 relative">
              By signing in, you agree to our <Link to="/terms" className="underline">Terms</Link> and <Link to="/privacy" className="underline">Privacy Policy</Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
